import type { Seccion } from '../rutas';

export function Proximo({ s }: { s: Seccion }) {
  return (
    <section class="panel">
      <h2>{s.nombre}</h2>
      <p>{s.proximo}</p>
      <p class="hint">Mientras tanto, esta parte se sigue haciendo en el prototipo.</p>
    </section>
  );
}
